import Message from "@/entities/Message";
import model from ".";

export default class Bot {
	static instructions = [
		{
			role: "system",
			content: "Your name is RasenganAI.",
		},
		{
			role: "system",
			content:
				"You are specialized in text generation, writing story, summarizing text, and more.",
		},
		{
			role: "system",
			content: "Provide concise and clear answers to user queries.",
		},
	];

	static startChat(history: Message[] = []) {
		const chat = model.startChat({
			history: [
				...history.map((message) => ({
					role: message.role,
					parts: [{ text: message.content }],
				})),
			],
		});

		return chat;
	}

	static async generateChatName(prompt: string) {
		const result = await model.generateContent(
			`Generate a title for the chat based on the following prompt: "${prompt}". The title should be concise and clear. Don't ask for more information.`
		);

		return result.response.text();
	}
}
